import { InputAdornment } from "@mui/material";
import { SingleTextFieldSubmit } from "@warden-ui/common-components";
import { CPLink } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentTeamDomainProps {
  teamDomain?: string;
  teamDomainPostfix?: string;
  showContact?: boolean;
  onClickFindTeamDomain?: (teamDomain: string) => void;
  onClickFindTeamDomainLink?: () => void;
  onClickContactLink?: () => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentTeamDomain = ({
  teamDomainPostfix,
  showContact = true,
  onClickFindTeamDomain,
  onClickFindTeamDomainLink,
  onClickContactLink,
  ...props
}: CardContentTeamDomainProps) => {
  const [ t ] = useTranslation();

  return (
    <CPCard>
      <SingleTextFieldSubmit
        title={t('team_domain.title')}
        hint={t('team_domain.hint')}
        label=""
        labelButton={t('buttons.next')}
        value={props.teamDomain}
        onClick={onClickFindTeamDomain}
        errorMessage={props.errorMessage}
        loading={props.loading}
        inputProps={{
          endAdornment: <InputAdornment position="start">{teamDomainPostfix}</InputAdornment>,
        }}
      />

      <CPLink
        prefix={t('team_domain.content.find_team_prefix')}
        label={t('team_domain.content.find_team')}
        onClick={onClickFindTeamDomainLink}
        sx={{ mt: 2 }}
      />

      {showContact && 
        <CPLink
          prefix={t('team_domain.content.contact_prefix')}
          label={t('team_domain.content.contact')}
          onClick={onClickContactLink}
          sx={{ mt: 1 }}
        />
      }
    </CPCard>
  );
};
